import React from 'react';
import PropTypes from 'prop-types';
import LogoAndName from "../icon-components/logo-and-name";
import Maintenance from "../icon-components/maintenance";

var MaintenanceScreen = function MaintenanceScreen(_ref) {
  var _ref$title = _ref.title,
      text = _ref$title.text,
      time = _ref$title.time,
      timeZone = _ref$title.timeZone,
      subTitle = _ref.subTitle;
  return React.createElement("div", {
    className: "MaintenanceScreen"
  }, React.createElement("div", {
    className: "MaintenanceScreen-logo"
  }, React.createElement(LogoAndName, null)), React.createElement("div", {
    className: "MaintenanceScreen-content"
  }, React.createElement("div", {
    className: "MaintenanceScreen-graphic"
  }, React.createElement(Maintenance, null)), React.createElement("p", {
    className: "MaintenanceScreen-title"
  }, text, "\xA0", React.createElement("span", {
    className: "MaintenanceScreen-highlighted"
  }, time), timeZone), React.createElement("p", {
    className: "MaintenanceScreen-subtitle"
  }, subTitle)));
};

MaintenanceScreen.displayName = 'MaintenanceScreen';
MaintenanceScreen.propTypes = {
  title: PropTypes.shape({
    text: PropTypes.string,
    time: PropTypes.string,
    timeZone: PropTypes.string
  }),
  subTitle: PropTypes.any
};
MaintenanceScreen.defaultProps = {
  title: {
    text: 'We\'re down for maintenance. We\'ll be back up by',
    time: '2 AM ',
    timeZone: 'EST.'
  },
  subTitle: 'Sorry for any inconvenience.'
};
export default MaintenanceScreen;